import api from '@/api/bankHolidays';

const state = {
  all: [],
};

const getters = {
  holidays: (state) => state.all,
};

const actions = {
  async getHolidays({ commit }) {
    const result = await api.getAll();
    commit('setHolidays', result.data);
    return result.data;
  },
  async createHoliday({ commit }, holiday) {
    const result = await api.post(holiday);
    commit('addHoliday', result.data);
    return result.data;
  },
  async updateHoliday({ commit }, holiday) {
    const result = await api.put(holiday);
    commit('updateHoliday', result.data);
    return result.data;
  },
  async deleteHoliday({ commit }, id) {
    await api.delete(id);
    commit('removeHoliday', id);
  },
};

const mutations = {
  setHolidays(state, holidays) {
    state.all = holidays;
  },
  addHoliday(state, holiday) {
    state.all.push(holiday);
  },
  updateHoliday(state, holiday) {
    const index = state.all.findIndex((h) => h.id === holiday.id);
    if (index !== -1) state.all.splice(index, 1, holiday);
  },
  removeHoliday(state, id) {
    const index = state.all.findIndex((h) => h.id === id);
    if (index !== -1) state.all.splice(index, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
